(function () {

  'use strict';

  eclipseApp.factory('manageCreditCardService', function() {

    var expiryMonth = '';
    var expiryYear = '';
    var CCNumber = '';
    var profileFirstName = '';
    var profileLastName = '';
    var cardStatus = '';
    var creditCardFlowIndicator = '';


    function setExpiryMonth(data) {
      expiryMonth = data;
    }

    function getExpiryMonth() {
      return expiryMonth;
    }

    function setProfileFirstName(data) {
      profileFirstName = data;
    }

    function getProfileFirstName() {
      return profileFirstName;
    }

    function setProfileLastName(data) {
      profileLastName = data;
    }

    function getProfileLastName() {
      return profileLastName;
    }

    function setExpiryYear(data) {
      expiryYear = data;
    }

    function getExpiryYear() {
      return expiryYear;
    }

    function setCCNumber(data) {
      CCNumber = data;
    }

    function getCCNumber() {
      return CCNumber;
    }

    function setCardStatus(data) {
      cardStatus = data;
    }

    function getCardStatus() {
      return cardStatus;
    }

    function setCreditCardFlowIndicator(data) {
      creditCardFlowIndicator = data;
    }

    function getCreditCardFlowIndicator() {
      return creditCardFlowIndicator;
    }


    return {
      setCCNumber: setCCNumber,
      getCCNumber: getCCNumber,
      setExpiryYear: setExpiryYear,
      getExpiryYear: getExpiryYear,
      setExpiryMonth: setExpiryMonth,
      getExpiryMonth: getExpiryMonth,
      setProfileFirstName: setProfileFirstName,
      getProfileFirstName: getProfileFirstName,
      setProfileLastName: setProfileLastName,
      getProfileLastName: getProfileLastName,
      setCardStatus: setCardStatus,
      getCardStatus: getCardStatus,
      setCreditCardFlowIndicator: setCreditCardFlowIndicator,
      getCreditCardFlowIndicator: getCreditCardFlowIndicator
    }

  });

})();
